<script setup lang="ts">
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VText from "@magnit/core/src/components/VText/VText.vue";
import CloseIcon from "@magnit/icons/src/assets/icons/close-24.svg";
import type { IAppBanner, IAppBannerEmits } from "./VInstallAppBanner.types";

withDefaults(defineProps<IAppBanner>(), {
  buttonTitle: "Открыть",
  title: "Приложение Магнит",
  subtitle: "Открыть приложение Магнит",
  loading: false,
  bottomShadow: false,
  buttonDisabled: false,
});
const emit = defineEmits<IAppBannerEmits>();

const onDownloadButtonClick = () => {
  emit("click");
};

const onClose = () => {
  emit("close");
};
</script>

<template>
  <div
    v-if="open"
    class="pl-install-app-banner"
    :class="{ 'pl-install-app-banner_bottom-shadow': bottomShadow }"
  >
    <div class="pl-install-app-banner__wrapper">
      <div class="pl-install-app-banner__close" @click="onClose">
        <CloseIcon />
      </div>
      <div class="pl-install-app-banner__icon">
        <slot name="icon" />
      </div>
      <div class="pl-install-app-banner__text">
        <VText tag="div" font="caption-large-accent-low">
          {{ title }}
        </VText>
        <VText tag="div" font="caption-small-regular-low">
          {{ subtitle }}
        </VText>
      </div>
      <VButton
        class="pl-install-app-banner__button"
        size="s"
        :disabled="buttonDisabled"
        :loading="loading"
        @click="onDownloadButtonClick"
      >
        {{ buttonTitle }}
      </VButton>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.pl-install-app-banner {
  display: flex;
  position: sticky;
  top: 0;
  z-index: var(--pl-z-index-overlay);
  width: 100%;
  height: 52px;
  flex-shrink: 0;

  @media (--pl-viewport-from-ml) {
    display: none;
  }

  @media all and (display-mode: standalone) {
    display: none;
  }

  &_bottom-shadow {
    box-shadow: var(--pl-shadow-s);
  }

  &__wrapper {
    padding: var(--pl-unit-x2) var(--pl-unit-x4);
    align-items: center;
    width: 100vw;
    max-width: 100vw;
    transition: top 0.2s;
    height: 52px;
    display: flex;
    z-index: 5;
    background: white;
  }

  &__close {
    color: var(--pl-text-secondary);
    display: flex;
    cursor: pointer;
    margin-right: var(--pl-unit-x1);
  }

  &__icon {
    display: flex;
  }

  &__text {
    display: flex;
    flex-direction: column;
    margin-left: var(--pl-unit-x2);
  }

  &__button {
    margin-left: auto;
  }
}
</style>
